import { createService } from 'reservice'
import {
  FETCH_PROPOSALS,
  FETCH_MULTIPLE_PROPOSALS,
  FETCH_NO_CACHE_PROPOSALS,
  CREATE_PROPOSALS,
  UPDATE_PROPOSALS,
  FETCH_CATEGORIES,
  FETCH_CATEGORIES_BY_SUB_STATIONS,
  FETCH_PROPOSAL_SUB_STATIONS,
  FETCH_CATEGORY_OPTIONS,
  FETCH_RECENTLY_CATEGORY_OPTIONS,
  FETCH_STRU_DATA_ATTR_CLUSTER_OPTIONS,
  FETCH_LISTINGS,
  FETCH_SPECIFIC_LISTING,
  FETCH_PRODUCTS,
  FETCH_SUB_STATION_ID_BY_CATITEM_ID,
  FETCH_LISTING_MODEL_PROPOSALS,
  CREATE_LISTING_MODEL_PROPOSALS,
  UPDATE_LISTING_MODEL_PROPOSALS,
  FETCH_LISTING_INFO_PROPOSAL,
  CREATE_LISTING_INFO_PROPOSAL,
  UPDATE_LISTING_INFO_PROPOSAL,
  FETCH_BATCH_PROPOSAL,
  CREATE_BATCH_PROPOSAL,
  UPDATE_BATCH_PROPOSAL,
  POST_BATCH_PROPOSAL,
  FETCH_BRANDS,
  FETCH_BAD_WORDS
} from '../actionTypes'

// proposal
export const fetchProposalSubStations = createService(FETCH_PROPOSAL_SUB_STATIONS)
export const fetchCategories = createService(FETCH_CATEGORIES)
export const fetchCategoriesBySubStations = createService(FETCH_CATEGORIES_BY_SUB_STATIONS)
export const fetchCategoryOptions = createService(FETCH_CATEGORY_OPTIONS)
export const fetchRecentlyCategoryOptions = createService(FETCH_RECENTLY_CATEGORY_OPTIONS)
export const fetchStruDataAttrClusterOptions = createService(FETCH_STRU_DATA_ATTR_CLUSTER_OPTIONS)
export const fetchBatchProposal = createService(FETCH_BATCH_PROPOSAL)
export const createBatchProposal = createService(CREATE_BATCH_PROPOSAL)
export const updateBatchProposal = createService(UPDATE_BATCH_PROPOSAL)
export const postBatchProposal = createService(POST_BATCH_PROPOSAL)
export const fetchProposals = createService(FETCH_PROPOSALS)
export const fetchMultipleProposals = createService(FETCH_MULTIPLE_PROPOSALS)
export const fetchNoCacheProposals = createService(FETCH_NO_CACHE_PROPOSALS)
export const createProposals = createService(CREATE_PROPOSALS)
export const updateProposals = createService(UPDATE_PROPOSALS)
export const fetchListings = createService(FETCH_LISTINGS)
export const fetchSpecificListing = createService(FETCH_SPECIFIC_LISTING)
export const fetchProducts = createService(FETCH_PRODUCTS)
export const fetchSubStationIdByCatItemId = createService(FETCH_SUB_STATION_ID_BY_CATITEM_ID)
export const fetchListingModelProposals = createService(FETCH_LISTING_MODEL_PROPOSALS)
export const createListingModelProposals = createService(CREATE_LISTING_MODEL_PROPOSALS)
export const updateListingModelProposals = createService(UPDATE_LISTING_MODEL_PROPOSALS)
export const fetchListingInfoProposal = createService(FETCH_LISTING_INFO_PROPOSAL)
export const createListingInfoProposal = createService(CREATE_LISTING_INFO_PROPOSAL)
export const updateListingInfoProposal = createService(UPDATE_LISTING_INFO_PROPOSAL)
export const fetchBrands = createService(FETCH_BRANDS)
export const fetchBadWords = createService(FETCH_BAD_WORDS)
